export enum ResourceRetryEnum {
    SecurityGroup = 'securityGroups',
    CloudUser= 'cloudUsers',
    CloudImage = 'cloudOs',
    CollectionPool= 'collections',
    CloudInstance  = 'cloudInstances',
    CloudApp = 'cloudApps',
    Deployment = 'notifications'
}
